import userRole from './userRole';

const clientWriteUserRoles = [
    userRole.localAdmin,
    userRole.write
];

export default clientWriteUserRoles;